// Adaptador: adminPhotos.ts → consume del motor contentMaster.ts
// Exporta las mismas interfaces y datos que esperan las páginas.

import {
  canonicalPhotos,
  canonicalAlbums,
  type CanonicalPhoto,
} from './contentMaster';

// Re-exportar tipos legacy (misma firma)
export type PhotoCategory = 'cabina' | 'eventos' | 'locutores' | 'comunidad' | 'promociones';

export interface AdminPhoto {
  id: number;
  title: string;
  imageUrl: string;
  albumId: number;
  category: PhotoCategory;
  isFeatured: boolean;
  fileSize: string;
  dimensions: string;
  uploadedAt: string;
}

export interface AdminAlbum {
  id: number;
  name: string;
  coverUrl: string;
  photoCount: number;
  category: PhotoCategory;
  createdAt: string;
}

export interface AdminPhotoData {
  photos: AdminPhoto[];
  albums: AdminAlbum[];
  storage: {
    used: string;
    total: string;
    percentage: number;
    usedGB: number;
    totalGB: number;
    photoCount: number;
  };
}

export const categoryLabels: Record<PhotoCategory, string> = {
  cabina: 'Cabina',
  eventos: 'Eventos',
  locutores: 'Locutores',
  comunidad: 'Comunidad',
  promociones: 'Promociones',
};

export const categoryIcons: Record<PhotoCategory, string> = {
  cabina: 'ri-broadcast-line',
  eventos: 'ri-calendar-event-line',
  locutores: 'ri-mic-line',
  comunidad: 'ri-group-line',
  promociones: 'ri-megaphone-line',
};

// ─── Mapeo de IDs canónicos a legacy ──────────────────────

function toLegacyPhotoId(canonicalId: string): number {
  return parseInt(canonicalId.split('-')[1], 10);
}

function toLegacyAlbumId(canonicalId: string): number {
  return parseInt(canonicalId.split('-')[1], 10);
}

function mapPhoto(p: CanonicalPhoto): AdminPhoto {
  return {
    id: toLegacyPhotoId(p.id),
    title: p.title,
    imageUrl: p.imageUrl,
    albumId: toLegacyAlbumId(p.albumId),
    category: p.category,
    isFeatured: p.isFeatured,
    fileSize: p.fileSize,
    dimensions: p.dimensions,
    uploadedAt: p.createdAt,
  };
}

// ─── Datos adaptados ──────────────────────────────────────

const adaptedPhotos: AdminPhoto[] = canonicalPhotos.map(mapPhoto);

const adaptedAlbums: AdminAlbum[] = canonicalAlbums.map((a) => {
  const coverPhoto = canonicalPhotos.find((p) => p.id === a.coverPhotoId);
  return {
    id: toLegacyAlbumId(a.id),
    name: a.name,
    coverUrl: coverPhoto ? coverPhoto.imageUrl : '',
    photoCount: a.photoCount,
    category: a.category as PhotoCategory,
    createdAt: a.createdAt,
  };
});

export const adminPhotoData: AdminPhotoData = {
  storage: {
    used: '2.8 GB',
    total: '15 GB',
    percentage: 19,
    usedGB: 2.8,
    totalGB: 15,
    photoCount: adaptedPhotos.length,
  },
  albums: adaptedAlbums,
  photos: adaptedPhotos,
};